// index.tsx
import React from 'react'; 
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, CssBaseline, GlobalStyles } from '@mui/material'; // <== GlobalStyles
import theme from './theme';
import '@fontsource/sanchez/400.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          ':root': { ['--header-height' as any]: '72px' }, // fallback até o Header setar o valor real
          '[id]': { scrollMarginTop: 'var(--header-height)' }, // âncoras visíveis
        }}
      />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
